import { StringOptions } from "../../../../../components/Select";
import { SortDir, SortKey, SortState } from "./types";

// Card list (mobile) sort is a single select, so each sortable dimension is
// flattened into an explicit direction. Mirrors the desktop table sort keys.
export const SORT_OPTIONS: StringOptions[] = [
  { label: "↓ Since", value: "since:desc" },
  { label: "↑ Since", value: "since:asc" },
  { label: "↓ Value", value: "value:desc" },
  { label: "↑ Value", value: "value:asc" },
  { label: "↓ Invested", value: "invested:desc" },
  { label: "↑ Invested", value: "invested:asc" },
  { label: "↓ Gain €", value: "gain:desc" },
  { label: "↑ Gain €", value: "gain:asc" },
  { label: "↓ Return %", value: "return:desc" },
  { label: "↑ Return %", value: "return:asc" },
];

export const sortStateToValue = ({ key, dir }: SortState): string =>
  `${key}:${dir}`;

export const valueToSortState = (value: string): SortState => {
  const [key, dir] = value.split(":");
  return { key: key as SortKey, dir: dir as SortDir };
};
